/** Fired when the signed-in role payload or Switch Role preview changes. */
export const PRIVILEGE_CHANGE_EVENT = 'tagp:privilege-change'

/** Tell mounted catalogs to reload. Sidebar state updates on its own. */
export function emitPrivilegeChange(): void {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new Event(PRIVILEGE_CHANGE_EVENT))
}
